































































































import { Component, Vue } from "vue-property-decorator";
import {
    createNewAccessKey, deleteAccessKey,
    listApplicationAccessPermissions,
    listApplicationAccessSessions
} from "../../endpoints";
import {Permission} from "@/types";
import DateFormat from "date-fns/format";

@Component
export default class Crawler extends Vue {

    DateFormat = DateFormat;

    accessSessions = [];
    accessPermissions: Permission[] = [];

    sessionKeyToBeDeleted: string = null;

    loadingSessions: boolean = false;
    submitted: boolean = false;

    addNewAccessKeyForm: {
        permissions: any[]
    } = {
        permissions: []
    };

    async mounted() {
        this.refreshApplicationAccessSessions();

        this.accessPermissions = await listApplicationAccessPermissions();
    }

    async refreshApplicationAccessSessions() {
        this.loadingSessions = true;
        this.accessSessions = await listApplicationAccessSessions();
        this.loadingSessions = false;
    }

    onPermissionAssignedChange(id: number) {
        if(this.addNewAccessKeyForm.permissions.indexOf(id) !== -1) {
            this.addNewAccessKeyForm.permissions = this.addNewAccessKeyForm.permissions.filter((permission: any) => {
                return permission !== id;
            });
        } else {
            this.addNewAccessKeyForm.permissions.push(id);
        }
    }

    async onGenerateAccessKeySubmitButtonClick() {
        this.submitted = true;

        try {
            this.accessSessions = await createNewAccessKey(JSON.stringify({
                permissions: this.addNewAccessKeyForm.permissions
            }));
            (this.$refs['generate-access-session-modal'] as any).hide();
        } catch(e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    onGenerateAccessKeyModalHidden() {
        this.addNewAccessKeyForm.permissions = [];
    }

    async onConfirmDeleteAccessKeyButtonClick() {

        this.submitted = true;
        try {
            this.accessSessions = await deleteAccessKey(this.sessionKeyToBeDeleted);
            this.sessionKeyToBeDeleted = null;
            (this.$refs['confirm-access-key-deletion'] as any).hide();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    onDeleteAccessKeyButtonClick(key: string) {
        this.sessionKeyToBeDeleted = key;
        (this.$refs['confirm-access-key-deletion'] as any).show();
    }

    get isAddNewAccessKeyFormValid() {
        return this.addNewAccessKeyForm.permissions.length > 0;
    }

}
